import React from 'react'
import classNames from 'classnames'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import IconButton, { IconButtonProps } from '@material-ui/core/IconButton'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles'

interface Props extends IconButtonProps {
}

const styles = createStyles({
  root: {
    position: 'absolute',
    left: 0,
    top: 0,
  },
})

type InjectedProps = Props & WithStyles<typeof styles> & RouteComponentProps<{}>

const NavigationBackButton: React.SFC<InjectedProps> = ({
  match,
  history,
  classes,
  location,
  className,
  staticContext,
  ...props
}) => {
  return (
    <IconButton
      className={classNames(className, classes.root)}
      onClick={() => history.goBack()}
      {...props}
    >
      <ArrowBackIcon />
    </IconButton>
  )
}

export default withRouter(withStyles(styles)(NavigationBackButton))
try {
    // @ts-ignore
    NavigationBackButton.displayName = "NavigationBackButton";
    // @ts-ignore
    NavigationBackButton.__docgenInfo = { "description": "", "displayName": "NavigationBackButton", "props": { "wrappedComponentRef": { "defaultValue": null, "description": "", "name": "wrappedComponentRef", "required": false, "type": { "name": "Ref<Component<RouteComponentProps<any, StaticContext, {}>, any, any>>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/NavigationBackButton/NavigationBackButton.tsx#NavigationBackButton"] = { docgenInfo: NavigationBackButton.__docgenInfo, name: "NavigationBackButton", path: "src/components/NavigationBackButton/NavigationBackButton.tsx#NavigationBackButton" };
}
catch (__react_docgen_typescript_loader_error) { }